import type { ApiResponse } from '../interfaces/api.interface'
import type { User, UserProfileUpdate } from '../interfaces/user.interface'
import { apiSlice } from './api-base.store'

const userEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentUser: builder.query<User, undefined>({
      query: () => '/users/me',
      transformResponse: (response: ApiResponse<User>) => response.data,
      providesTags: ['User'],
    }),

    updateProfile: builder.mutation<User, UserProfileUpdate>({
      query: (body) => ({
        url: '/users/me',
        method: 'PATCH',
        body,
      }),
      transformResponse: (response: ApiResponse<User>) => response.data,
      invalidatesTags: ['User'],
    }),
  }),
})

export const { useGetCurrentUserQuery, useUpdateProfileMutation } = userEndpoints
